// Tier-2 <Card> with header/body/footer slots, backed by AntD Card (FORT-182).
// Body padding and radius come from design tokens so surface metrics are uniform
// across the app — no raw px at the call site.
import React from 'react';
import { Card as AntCard } from 'antd';
import { useTokens } from '../../core/theme/TokensProvider';
import type { CommonProps } from './types';

export interface CardProps extends CommonProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'default' | 'small';
  children: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({
  header,
  footer,
  size = 'default',
  children,
  className,
  style,
  'data-testid': dataTestId,
}) => {
  const tokens = useTokens();
  return (
    <AntCard
      title={header}
      size={size}
      styles={{ body: { padding: tokens.space[5] } }}
      style={{ borderRadius: tokens.radius.lg, ...style }}
      actions={footer ? [footer] : undefined}
      className={className}
      data-testid={dataTestId}
    >
      {children}
    </AntCard>
  );
};
